import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { ParticipantDocumentRow } from './ParticipantDocumentRow';

export function ParticipantDocumentList({ documents, participantId, canManage, canDownload, canPreview, onArchive, onEdited }) {
  return (
    <div className="border rounded-lg overflow-hidden" data-testid="doc-list-table">
      <Table>
        <TableHeader>
          <TableRow className="bg-muted/30">
            <TableHead className="text-xs font-medium">Document</TableHead>
            <TableHead className="text-xs font-medium w-[120px]">Type</TableHead>
            <TableHead className="text-xs font-medium w-[110px]">Uploaded</TableHead>
            <TableHead className="text-xs font-medium w-[110px]">Expiry</TableHead>
            <TableHead className="text-xs font-medium w-[130px]">Uploaded By</TableHead>
            <TableHead className="text-xs font-medium w-[120px] text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {documents.map((doc) => (
            <ParticipantDocumentRow
              key={doc.id}
              doc={doc}
              participantId={participantId}
              canManage={canManage}
              canDownload={canDownload}
              canPreview={canPreview}
              onArchive={onArchive}
              onEdited={onEdited}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
